import {
  LAST_VB_RECOMMENDATION_INDEX,
  RECOMMENDATIONS,
} from '../clientSetting/constants'

export const getNextRecommendations = (size = 4) => {
  const nextRecommendations = []

  const localStorageLastIndex = localStorage.getItem(
    LAST_VB_RECOMMENDATION_INDEX
  )
  let lastIndex = localStorageLastIndex ? Number(localStorageLastIndex) : 0

  for (let i = 0; i < size; i++) {
    const index = (lastIndex + i) % RECOMMENDATIONS.length
    nextRecommendations.push(RECOMMENDATIONS[index])
  }

  lastIndex = (lastIndex + size) % RECOMMENDATIONS.length
  localStorage.setItem(LAST_VB_RECOMMENDATION_INDEX, lastIndex)

  return nextRecommendations
}

export const decrementLastRecommendationsIndex = () => {
  const localStorageLastIndex = localStorage.getItem(
    LAST_VB_RECOMMENDATION_INDEX
  )
  let lastIndex = Number(localStorageLastIndex)
  const newLastIndex =
    lastIndex === 0 ? RECOMMENDATIONS.length - 1 : lastIndex - 1

  localStorage.setItem(LAST_VB_RECOMMENDATION_INDEX, newLastIndex)
}
